import { useEffect } from 'react';

var useOnClickOutside = function useOnClickOutside(ref, onClickOutside) {
  var enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var stopPropagation = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var exceptionElements = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      var exceptionElementIsClicked = exceptionElements.some(function (el) {
        return el.contains(event.target);
      });
      if (!ref.current || ref.current.contains(event.target) || exceptionElementIsClicked) {
        return;
      }
      if (stopPropagation) event.stopPropagation();
      onClickOutside(event);
    };
    if (enabled) {
      document.addEventListener('click', handleClickOutside, true);
      return function () {
        document.removeEventListener('click', handleClickOutside, true);
      };
    }
    return undefined;
  }, [ref, onClickOutside, enabled, stopPropagation, exceptionElements]);
};
var useOnClickOutside$1 = useOnClickOutside;

export { useOnClickOutside$1 as default };
//# sourceMappingURL=useOnClickOutside.js.map
